import { render, staticRenderFns } from "./SaveSeriesQuestion.vue?vue&type=template&id=489197b0&"
import script from "./SaveSeriesQuestion.vue?vue&type=script&lang=js&"
export * from "./SaveSeriesQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports